import ReactPaginate, { ReactPaginateProps } from 'react-paginate'

interface Props extends ReactPaginateProps {
  align?: 'left' | 'center' | 'right'
}

export const Pagination: React.FC<Props> = ({
  forcePage,
  pageCount,
  onPageChange,
  disableInitialCallback = true,
  marginPagesDisplayed = 1,
  pageRangeDisplayed = 2,
  containerClassName = 'pagination',
  pageClassName = 'page-item',
  pageLinkClassName = 'page-link',
  activeClassName = 'active',
  previousLabel = '<',
  nextLabel = '>',
  previousClassName = 'page-item',
  nextClassName = 'page-item',
  previousLinkClassName = 'page-link',
  nextLinkClassName = 'page-link',
  disabledClassName = 'disabled',
  breakLabel = '...',
  breakClassName = 'page-item',
  breakLinkClassName = 'page-link',
  align = 'center',
}) => {
  const textAlign = `text-${align}`
  return (
    <div className={textAlign}>
      <ReactPaginate
        forcePage={forcePage}
        pageCount={pageCount}
        marginPagesDisplayed={marginPagesDisplayed}
        pageRangeDisplayed={pageRangeDisplayed} //上記の「今いるページの前後」の番号をいくつ表示させるか
        onPageChange={onPageChange} //ページネーションのリンクをクリックしたときのイベント
        disableInitialCallback={disableInitialCallback}
        containerClassName={containerClassName} //ページネーションリンクの親要素のクラス名
        pageClassName={pageClassName} //各子要素(li要素)のクラス名
        pageLinkClassName={pageLinkClassName} //ページネーションのリンクのクラス名
        activeClassName={activeClassName} //今いるページ番号のクラス名。
        previousLabel={previousLabel} //前のページ番号に戻すリンクのテキスト
        nextLabel={nextLabel} //次のページに進むボタンのテキスト
        previousClassName={previousClassName} // '<'の親要素(li)のクラス名
        nextClassName={nextClassName} //'>'の親要素(li)のクラス名
        previousLinkClassName={previousLinkClassName} //'<'のリンクのクラス名
        nextLinkClassName={nextLinkClassName} //'>'のリンクのクラス名
        disabledClassName={disabledClassName} //先頭 or 末尾に行ったときにそれ以上戻れ(進め)なくするためのクラス
        breakLabel={breakLabel} // ページがたくさんあるときに表示しない番号に当たる部分の表示
        breakClassName={breakClassName} // 上記の「…」のクラス名
        breakLinkClassName={breakLinkClassName} // 「…」の中のリンクにつけるクラス
      />
    </div>
  )
}
